/**
 * CurrencyContextProvider Component
 */

import { pushNotification } from '../../redux/actions/notifications';
import { ChangeCurrencyMutation } from '../../relay/currency';
import { selectedCurrency } from '../../relay/selectedCurrency';
import { processMutation } from '../../utils/relay';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { createFragmentContainer } from 'react-relay';

import LoadingSpinner from '../../components/atoms/feedback/LoadingSpinner';
import { CurrencyContext } from './';
import { ICurrencyContext, SetCurrencyHandler } from './types';

interface IOwnDispatchProps {
  pushErrorNotification(): void;
}

interface ICurrencyContextProviderProps {
  viewer: GQL.IViewer;
}

interface ICurrencyContextProviderState extends ICurrencyContext {
  submitting: boolean;
}

// tslint:disable-next-line:max-line-length
class CurrencyContextProviderBase extends React.Component<ICurrencyContextProviderProps & IOwnDispatchProps, ICurrencyContextProviderState> {
  constructor(props) {
    super(props);

    this.state = {
      currency: this.props.viewer.selected_currency || 'CAD' as GQL.Currency,
      setCurrency: this.setCurrency,
      submitting: false,
    };
  }

  setCurrency: SetCurrencyHandler = (currency) => {
    this.setState({ submitting: true }, async () => {
      try {
        const { errors } = await processMutation<GQL.IChangeCurrencyInput>(ChangeCurrencyMutation, { currency });
        if (errors) {
          throw errors;
        }
      } catch (error) {
        console.log(error);
        this.props.pushErrorNotification();
        this.setState({ submitting: false });
      }
    });
  }

  componentDidUpdate(prevProps: ICurrencyContextProviderProps) {
    if (prevProps.viewer.selected_currency !== this.props.viewer.selected_currency) {
      window.location.reload();
    }
  }

  render() {
    return (
      <CurrencyContext.Provider value={this.state}>
        {this.props.children}
        {this.state.submitting && ReactDOM.createPortal(
          <CurrencyLoadingScreen />,
          document.getElementsByClassName('drawer-wrapper')[0],
        )}
      </CurrencyContext.Provider>
    );
  }
}

const CurrencyLoadingScreen = () => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255,255,255,.5)',
    }}
  >
    <LoadingSpinner center />
  </div>
);

const ConnectedCurrencyContextProvider = connect<{}, IOwnDispatchProps, ICurrencyContextProviderProps, IStoreState>(
  null,
  (dispatch) => ({
    pushErrorNotification: () => {
      dispatch(pushNotification({
        state: 'error',
        message: 'Something went wrong while changing currency. Please try again later or contact us.',
      }));
    },
  }),
)(CurrencyContextProviderBase);

export const CurrencyContextProvider = createFragmentContainer(
  ConnectedCurrencyContextProvider,
  selectedCurrency,
) as React.ComponentClass<ICurrencyContextProviderProps>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/currency/provider.tsx